var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18743 13.3333C3.0844 13.3333 2.98369 13.3028 2.89802 13.2456C2.81235 13.1883 2.74558 13.107 2.70616 13.0118C2.66673 12.9166 2.65641 12.8119 2.67652 12.7109C2.69662 12.6098 2.74624 12.517 2.8191 12.4442L12.4439 2.81922C12.5416 2.72154 12.6741 2.66666 12.8123 2.66666C12.9504 2.66666 13.0829 2.72154 13.1806 2.81922C13.2783 2.91691 13.3332 3.0494 13.3332 3.18756C13.3332 3.32571 13.2783 3.4582 13.1806 3.55589L3.55575 13.1808C3.50743 13.2292 3.45001 13.2676 3.3868 13.2938C3.3236 13.32 3.25584 13.3334 3.18743 13.3333Z",
    fill: "#2A2E34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8122 13.3333C12.7438 13.3334 12.6761 13.32 12.6129 13.2938C12.5497 13.2676 12.4922 13.2292 12.4439 13.1808L2.81907 3.55589C2.72138 3.4582 2.6665 3.32571 2.6665 3.18756C2.6665 3.0494 2.72138 2.91691 2.81907 2.81922C2.91676 2.72154 3.04925 2.66666 3.1874 2.66666C3.32555 2.66666 3.45804 2.72154 3.55573 2.81922L13.1806 12.4442C13.2534 12.517 13.3031 12.6098 13.3232 12.7109C13.3433 12.8119 13.3329 12.9166 13.2935 13.0118C13.2541 13.107 13.1873 13.1883 13.1017 13.2456C13.016 13.3028 12.9153 13.3333 12.8122 13.3333Z",
    fill: "#2A2E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c912a2ae95fe18d38590bc449d4ab8b9.svg";
export { ForwardRef as ReactComponent };